import React from "react";
import classNames from "classnames";

import Logo from "../logo/Logo.jsx";
import "./styles.styl";
import { FormattedMessage } from "react-intl";

export default function Terms(props) {
  const { conditionsPage, logoSmallUrl, className, gmbhName, ...rest } = props;

  return (
    <div className={classNames("terms", className)} {...rest}>
      <Logo className="terms__logo" logoSmallUrl={logoSmallUrl} />
      <p>
        {" "}
        <FormattedMessage id="findTermsHere" />
      </p>
      <div className="terms__link">
        <a rel="noreferrer" target="_blank" href={`https://${conditionsPage}`}>
          <FormattedMessage id="termsAndConditionsHc" /> {gmbhName}
        </a>{" "}
      </div>
    </div>
  );
}
